import { useEffect, useState, useContext, useCallback } from 'react';
import { debounceAsync } from '../PropertyFormat/PropertyFormat';
import { getAllUserBuyer,getAllVesselsSupplier } from '../../../redux/actions/rfqManagementApi';
import { useDispatch } from 'react-redux';
import AuthContext from '../../../store/AuthContext'

const useBuyerSuplierSearch = () => {
    const [options, setOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    const ctx = useContext(AuthContext);

    const debouncedFetchPortOptions = debounceAsync(async (cursor, query, isLoadMore) => {
        setIsLoading(true);
if( ctx.userData.user_organizations[0].user_org_role_maps[0].platform_role !== 'supplier')
      {  const req = {
            organization_name: query ? query : '',
        };

        const response = await Promise.resolve(dispatch(getAllUserBuyer(req)));

        if (response && response.payload) {
            setOptions(
                (response.payload.payload || []).map((_a) => ({
                    ..._a,
                    name: _a.organization_name,
                    ulid: _a.ulid,
                    label: _a.organization_name,
                }))
            );
        }}
       else {const response = await Promise.resolve(dispatch(getAllVesselsSupplier(ctx.userData.user_organizations[0].user_org_role_maps[0].organization_ulid)));
        if (response && response.payload) {
            setOptions(
                (response.payload || []).map((_a) => (
                    {
                    ..._a,
                    name: _a.buyer_organization_name,
                    ulid: _a.buyer_organization_ulid,
                    label: _a.buyer_organization_name,
                }))
            );
        }}
        setIsLoading(false);
    }, 1000);

    const search = useCallback(
        (query) => {
            debouncedFetchPortOptions(0, query, false);
        },
        [debouncedFetchPortOptions]
    );

    useEffect(() => {
        if (!ctx.isSessionReady) return;
        debouncedFetchPortOptions(0, '', false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ctx.isSessionReady]);

    return {
        options,
        isLoading,
        search,
    };
};

export default useBuyerSuplierSearch;
